import {fromJS} from 'immutable';

import {
  GET_MANAGER_INSIGHTS_REQUEST,
  MANAGER_LOGGED_IN,
  OTP_ERROR,
  RESET_OTP_ERROR,
  SET_MANAGER_INSIGHTS_SELECTED_STORE,
} from './managerInsightsActionTypes';

const UNAUTHORISED_STATUS_CODE = 401;

export const initialState = fromJS({
  insights: {},
  selectedStoreId: null,
  loading: true,
  loaded: false,
  loadingError: false,
  needToAuthenticate: false,
  otpError: '',
});

// eslint-disable-next-line complexity
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MANAGER_INSIGHTS_REQUEST:
      return state.set('loading', true);
    case `${GET_MANAGER_INSIGHTS_REQUEST}_FAIL`:
    case `${GET_MANAGER_INSIGHTS_REQUEST}_ROLLBACK`:
      if (action.payload.error.response.status === UNAUTHORISED_STATUS_CODE) {
        return state.set('loading', false).set('needToAuthenticate', true);
      }
      return state.set('loadingError', true);
    case `${GET_MANAGER_INSIGHTS_REQUEST}_SUCCESS`: {
      let data = action.payload.data;

      return state
        .set('insights', fromJS(data))
        .set('loaded', true)
        .set('loading', false)
        .set('loadingError', false);
    }
    case MANAGER_LOGGED_IN: {
      return state.set('needToAuthenticate', false).set('loading', true);
    }
    case SET_MANAGER_INSIGHTS_SELECTED_STORE:
      return state.set('selectedStoreId', action.payload.storeId);

    case OTP_ERROR:
      return state.set('otpError', action.payload.otpError);
    case RESET_OTP_ERROR:
      return state.set('otpError', '');
    default:
      return state;
  }
};
